<template>
  <div>
    <van-sticky>
      <div class="nav">
        <div class="flex">
          <template v-if="$route.name === 'contractSummary'">
            <div @click="showPickerStart = true">
              {{ startYear }}年{{ startMonth }}月 <van-icon name="arrow-down" />
            </div>
            <div class="midIcon">-</div>
          </template>
          <div @click="showPicker = true">
            {{ year }}年{{ month }}月
            <van-icon name="arrow-down" />
          </div>
        </div>
        <img
          @click="showPickerMenu = true"
          class="iconImg"
          src="@/assets/menu.png"
          alt=""
          srcset=""
        />
      </div>
    </van-sticky>

    <div class="container">
      <router-view />
    </div>
    <van-popup v-model:show="showPicker" position="bottom">
      <!-- <monthPicker
        @cancel="showPicker = false"
        :defaultIndex="month"
        @confirm="onConfirm"
      /> -->
      <van-date-picker
        v-model="currentDate"
        type="date"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        :columns-type="['year', 'month']"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
    <van-popup v-model:show="showPickerStart" position="bottom">
      <!-- <monthPicker
        @cancel="showPicker = false"
        :defaultIndex="month"
        @confirm="onConfirm"
      /> -->
      <van-date-picker
        v-model="currentStartDate"
        type="date"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        :columns-type="['year', 'month']"
        @confirm="startConfirm"
        @cancel="showPickerStart = false"
      />
    </van-popup>
    <van-popup v-model:show="showPickerMenu" position="right">
      <div class="menu">
        <div
          class="item"
          :class="{ active: item.name === activeRouter }"
          v-for="(item, index) in marketStatisticsRouter"
          :key="index"
          @click="handleRouter(item.name)"
        >
          {{ item.meta.title }}
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
  // import monthPicker from "@/components/monthPicker.vue";
  import { marketStatisticsRouter } from "@/router/marketStatisticsRouter.js";
  export default {
    // components: { monthPicker },
    data() {
      return {
        marketStatisticsRouter: marketStatisticsRouter,
        showPicker: false,
        showPickerStart: false,
        showPickerMenu: false,
        minDate: new Date(new Date().getFullYear() - 10, 0),
        maxDate: new Date(),
      };
    },
    computed: {
      currentDate() {
        return [
          this.year.toString(),
          this.month < 10 ? "0" + this.month : this.month.toString(),
        ];
      },
      currentStartDate() {
        return [
          this.startYear.toString(),
          this.startMonth < 10
            ? "0" + this.startMonth
            : this.startMonth.toString(),
        ];
      },
      year() {
        return this.$store.state.user.year;
      },
      month() {
        return this.$store.state.user.month;
      },
      startYear() {
        return this.$store.state.user.startYear;
      },
      startMonth() {
        return this.$store.state.user.startMonth;
      },
      activeRouter() {
        return this.$route.name;
      },
    },
    methods: {
      onConfirm(val) {
        this.$store.state.user.year = val.selectedOptions[0].value;
        this.$store.state.user.month =
          val.selectedOptions[1].value !== "10"
            ? val.selectedOptions[1].value.replace("0", "")
            : val.selectedOptions[1].value;
        this.showPicker = false;
      },
      startConfirm(val) {
        this.$store.state.user.startYear = val.selectedOptions[0].value;
        this.$store.state.user.startMonth =
          val.selectedOptions[1].value.replace("0", "");
        this.showPickerStart = false;
      },
      handleRouter(name) {
        this.$router.push({ name });
      },
    },
    mounted() {
      let month = new Date().getMonth() + 1;
      this.$store.state.user.month = month;
    },
  };
</script>
<style lang="scss" scoped>
  .nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid #ccc;
    background: #fff;
    height: 50px;
    box-sizing: border-box;
    .midIcon {
      padding: 0 10px;
    }
    .iconImg {
      width: 20px;
    }
  }
  .menu {
    height: 100vh;
    padding: 10px;
    box-sizing: border-box;
    .item {
      margin-bottom: 10px;
      font-size: 18px;
      &.active {
        color: #407eff;
        position: relative;
        padding-left: 10px;
        &::after {
          content: "";
          position: absolute;
          top: 5px;
          left: 0;
          height: 16px;
          width: 2px;
          background: #407eff;
        }
      }
    }
  }
  .container {
    padding: 0 10px 50px 10px;
  }
</style>
